import { render, staticRenderFns } from "./AddMediaButton.vue?vue&type=template&id=328d42f2&"
import script from "./AddMediaButton.vue?vue&type=script&lang=js&"
export * from "./AddMediaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QTooltip,QBadge,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QTooltip,QBadge,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
